import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { useSelector } from "react-redux";
import { selectAllUniqueWebsites } from "../store/selectors";

function useTrackedWebsitesQuota() {
    const uniqueWebsitesTracked = useSelector(selectAllUniqueWebsites);
    const quotaLimit = salesSettingsHelper.getQuotaLimit();
    const remaining = quotaLimit - uniqueWebsitesTracked.length;
    const isOutOfQuota = remaining <= 0;

    return {
        isOutOfQuota,
        remaining: remaining < 0 ? 0 : remaining,
    };
}

export default useTrackedWebsitesQuota;
